var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{class:[_vm.$style.link, { WishListLink__disabled: _vm.isDisabled }],on:{"click":_vm.handleClick}},[_c('i',{staticClass:"fas fa-file-medical"}),_vm._v(_vm._s(_vm.config.text)+"\n")])}
var staticRenderFns = []

export { render, staticRenderFns }